import { IFitmentDetail } from "api/interfaces/product-api.type";
import classNames from "classnames";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import matchMediaConst from "constant/matchmedia";
import { useCustomScreenSize } from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import commonStyles from "modules/fitment-notes/style.module.scss";
import { useTranslation } from "next-i18next";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import styles from "../fitment/product-fitment.module.scss";
import RenderFitmentNotes from "./RenderFitmentNotes";

interface IProps {
  fitmentNote: IFitmentDetail,
  expanded: boolean;
  isContentOverflowing?: boolean;
  setIsContentOverflowing?: (contentOverflow: boolean) => void;
  showSeparator?: boolean;
}

function FitmentNotesContainer(props: IProps) {
  const {
    fitmentNote, expanded, isContentOverflowing, setIsContentOverflowing, showSeparator = false,
  } = props;

  const contentRef = useRef(null);
  const { jsonNote, htmlNote } = fitmentNote || {};
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const { t } = useTranslation(["product", "category"]);

  const isMobile = useCustomScreenSize({
    maxWidth: matchMediaConst.XS_MAX,
  });

  useEffect(() => {
    if (contentRef?.current && setIsContentOverflowing) {
      const contentHeight = contentRef?.current?.scrollHeight;
      setIsContentOverflowing(contentHeight > 64);
    }
  }, [htmlNote, jsonNote]);

  // for product page
  if ((!jsonNote || (jsonNote && Object.keys(jsonNote).length === 0)) && !htmlNote) {
    return null;
  }

  const showMore = PRODUCT_PAGE_TYPES.includes(currentPageType);

  return (
    <div>
      <HideIf show={showSeparator}>
        <HorizontalSeparator className="m-t-0 m-b-5" />
      </HideIf>
      <PAText component="span" className={styles.dark_grey} fontSize={FONT_SIZE[0]}>
        {`${t("verify_specifics") }:`}
      </PAText>
      <div className={styles.engine_description}>
        <div className={styles.extended_description_container}>
          <div
            className={classNames(commonStyles.faded_container, {
              [commonStyles.show_all]: expanded || !isMobile || !showMore || isContentOverflowing,
              [commonStyles.show_shrinked_fitment]: !expanded && isMobile && showMore && isContentOverflowing,
            }, "p-0")}
          >
            <div
              className={commonStyles.product_extended_definition}
              ref={contentRef}
            >
              <RenderFitmentNotes
                fitmentDetail={fitmentNote}
              />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default FitmentNotesContainer;
